import { render, staticRenderFns } from "./formatPdf.vue?vue&type=template&id=8db01976&lang=pug&"
import script from "./formatPdf.vue?vue&type=script&lang=js&"
export * from "./formatPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports